import { Button, makeStyles, Modal } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import { allHotelsSelector } from '../../layouts/property/propertySlice';
import CustomTextField from '../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../utils/formUtils';
import { notificationManager } from '../../utils/NotificationUtils';
import './Device-Enabling-Popup.scss';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 550,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const DeviceEnablingPopup = (props) => {
  const classes = useStyles();
  const { currentStatus, onCancel, onEnabling } = props;
  const [modalStyle] = useState(getModalStyle);
  const allHotels = useSelector(allHotelsSelector);
  const [isValid, setIsValid] = useState(false);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    endpoint: {
      value: '',
      fieldName: 'End-point URL',
      errors: {},
      validations: ['required', 'validUrl'],
      tab: 0,
    },
  });

  useEffect(() => {
    const isValid = formDataValidate(formData, false);
    setIsValid(isValid);
  }, [formData]);

  const handleOnSubmit = () => {
    if (isValid) {
      onEnabling(formData.endpoint.value);
    } else {
      notificationManager('danger', 'Invalid format in end-point URL');
    }
  };

  const getHotelNameFromId = () => {
    return allHotels.find((hotel) => hotel.id === currentStatus.id)?.name;
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='my-4 device-popup d-flex flex-column'>
        <div className='mb-5'>
          <div className='device-popup-header mb-4 text-center'>
            Enable Device Monitoring Module for
            <div>{getHotelNameFromId()}</div>
          </div>
          <div className='device-popup-description mb-4 text-center'>
            To enable device monitoring module for this hotel, please add the End-Point URL below.
          </div>
          <CustomTextField
            item={formData.endpoint}
            handleInputChange={(e) => {
              setFormData({ endpoint: e });
            }}
            placeholder='Enter URL'
          />
        </div>

        <div className='w-100 d-flex justify-content-center'>
          <Button onClick={onCancel} variant='outlined' type='button' className='me-3' size='large'>
            Cancel
          </Button>
          <Button
            onClick={(e) => {
              handleOnSubmit();
            }}
            variant='contained'
            type='submit'
            color={'primary'}
            disabled={!isValid}
            className='me-3'
            size='large'
          >
            Enable
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Modal open={currentStatus.deviceEnabling} onClose={onCancel}>
      {body}
    </Modal>
  );
};

export default DeviceEnablingPopup;
